<template>
  <main class="view default" v-if="!kql.loading">
    <header class="page-header">
      <h1 v-html="kql.page?.title" />
    </header>
    <section class="content" v-if="layout">
      <LayoutComponent :layout="layout" :context="kql.page" />
    </section>
    <MainFooter />
  </main>
</template>

<script setup>
import { useStore } from '@/KQL.js'
import { yamlToObject } from '@/utils'

const kql = useStore()
const layout = computed(() => yamlToObject(kql.page?.layout))
</script>

<style scoped>
.default {
  padding-top: var(--header-height);
}

.page-header {
  padding: 8rem var(--offset) 4rem;
  border-bottom: 1px solid var(--fg-20);
  margin-bottom: 6rem;
}

.content {
  padding: 0 var(--offset);
  max-width: var(--main-width-narrow);
  margin: 0 auto;
}
</style>
